module.exports = __webpack_public_path__ + "static/media/viva.433e72bc.jpg";